
export const frontSkillsList = [
  {
    label: "HTML5",
    src: "https://img.icons8.com/color/480/000000/html-5--v1.png",
  },
  {
    label: "CSS3",
    src: "https://img.icons8.com/color/480/000000/css3.png",
  },
  {
    label: "Javascript",
    src: "https://img.icons8.com/color/480/000000/javascript.png",
  },
  {
    label: "React",
    src: "https://img.icons8.com/color/480/000000/react-native.png",
  },
  {
    label: "Redux",
    src: "https://img.icons8.com/color/480/000000/redux.png",
  },
  {
    label: "Chakra UI",
    src: "https://images.opencollective.com/chakra-ui-pro/61bd1dd/logo/256.png",
  },
  {
    label: "Bootstrap",
    src: "https://i.ibb.co/zx0Tt9M/bootstrap.png",
  },
  {
    label: "NPM",
    src: "https://img.icons8.com/color/480/000000/npm.png",
  },
 
];

export const backSkillsList = [
  {
    label: "HTML5",
    src: "https://img.icons8.com/color/480/000000/html-5--v1.png",
  },
  {
    label: "CSS3",
    src: "https://img.icons8.com/color/480/000000/css3.png",
  },
  {
    label: "Javascript",
    src: "https://img.icons8.com/color/480/000000/javascript.png",
  },
  {
    label: "React",
    src: "https://img.icons8.com/color/480/000000/react-native.png",
  },
  {
    label: "Redux",
    src: "https://img.icons8.com/color/480/000000/redux.png",
  },
  {
    label: "Chakra UI",
    src: "https://images.opencollective.com/chakra-ui-pro/61bd1dd/logo/256.png",
  },
  {
    label: "Bootstrap",
    src: "https://i.ibb.co/zx0Tt9M/bootstrap.png",
  },
  {
    label: "NPM",
    src: "https://img.icons8.com/color/480/000000/npm.png",
  },
  {
    label: "Node JS",
    src: "https://img.icons8.com/color/480/000000/nodejs.png",
  },
  {
    label: "Express JS",
    src: "https://i.ibb.co/9smDM6j/pngegg.png",
  },
  {
    label: "Mongo dB",
    src: "https://i.ibb.co/ZVh01dm/rsz-mong2.png",
  },
  {
    label: "Heroku",
    src: "https://cdn-icons-png.flaticon.com/512/873/873120.png"
  },
//   {
//     label: "Go Lang",
//     src:"https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Go_Logo_Blue.svg/1200px-Go_Logo_Blue.svg.png",
//  },
 {
   label: "MySql",
   src:"https://www.freepnglogos.com/uploads/logo-mysql-png/logo-mysql-mysql-logo-png-images-are-download-crazypng-21.png",
 },
 {
   label: "DataDog",
   src:"https://mma.prnewswire.com/media/1434744/Datadog_Logo.jpg",
 },
 {
   label: "Grafana",
   src:"https://upload.wikimedia.org/wikipedia/commons/thumb/a/a1/Grafana_logo.svg/1200px-Grafana_logo.svg.png",
 },
 {
   label: "Prometheus",
   src:"https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Prometheus_software_logo.svg/1200px-Prometheus_software_logo.svg.png",
 },
 {
  label: "TypeScript",
  src:"https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Typescript_logo_2020.svg/2048px-Typescript_logo_2020.svg.png"
 }
];


